import {Link} from 'react-router-dom';

const Error = () => {
    return (
        <>

            <div>

                <Link to="/">
                    بازگشت به خانه
                </Link>

            </div>
        </>
    )
        ;
};

export default Error;
